module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (13).16d392fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (13).jpg
// module id = 335
// module chunks = 0